"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debugInfo = void 0;
/**
 * If the app is in debug mode, prints an info to the console. In production builds, this function does nothing.
 *
 * @param args
 */
const debugInfo = (...args) => {
    if (typeof process !== 'undefined' && process.env?.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.info(...args);
    }
};
exports.debugInfo = debugInfo;
